class TabindexSwitch {
  private readonly parentElement: HTMLElement;
  private tabbableElementsSelector: string;
  private tabbableElements: HTMLElement[] = [];
  private originalTabindexValues: (string | null)[] = [];

  constructor(
    parentElement: HTMLElement,
    tabbableElementsSelector: string = "button, input, select, textarea, a[href]",
  ) {
    this.parentElement = parentElement;
    this.tabbableElementsSelector = tabbableElementsSelector;
    this.scanElements();
  }

  public scanElements(tabbableElementsSelector?: string) {
    if (tabbableElementsSelector) {
      this.tabbableElementsSelector = tabbableElementsSelector;
    }

    this.tabbableElements = Array.from(
      this.parentElement.querySelectorAll<HTMLElement>(
        this.tabbableElementsSelector
      )
    );

    this.originalTabindexValues = this.tabbableElements.map(
      (element) => element.getAttribute("tabindex")
    );
  }

  public disableTabindex() {
    this.tabbableElements.forEach((element) => {
      element.blur();
      element.setAttribute("tabindex", "-1");
    });
  }

  public enableTabindex() {
    this.tabbableElements.forEach((element, index) => {
      const originalTabIndexValue = this.originalTabindexValues[index];

      if (originalTabIndexValue) {
        element.setAttribute("tabindex", originalTabIndexValue);
      }
      else {
        element.removeAttribute("tabindex");
      }
    });
  }
}

export default TabindexSwitch;
